import { render } from "./DownloadHistory.vue?vue&type=template&id=47246b8e&scoped=true"
import script from "./DownloadHistory.vue?vue&type=script&lang=js"
export * from "./DownloadHistory.vue?vue&type=script&lang=js"

import "./DownloadHistory.vue?vue&type=style&index=0&id=47246b8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47246b8e"]])

export default __exports__